import { Box, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import TextWithLineBreaks from '../TextWithLineBreaks/TextWithLineBreaks';
import { useDefaultShopStyles } from '../../hooks/useDefaultShopStyles';

interface HighlightBannerProps {
  text: string;
  color?: string;
}

const HighlightBanner: FC<HighlightBannerProps> = (props: HighlightBannerProps) => {
  const { text, color } = props;
  const defaultShopStyles = useDefaultShopStyles();

  return (
    <Box bgcolor={color || defaultShopStyles.shopColor80} p={2} textAlign="center">
      <Typography variant="body1" style={{ color: 'white' }}>
        <TextWithLineBreaks text={text} />
      </Typography>
    </Box>
  );
};

export default HighlightBanner;
